import React, { useState, useRef } from 'react';
import styled from 'styled-components'
import useElementInertialParallax from '../../../hooks/useElementInertialParallax'

const ImageContainer = styled.div`
    position:relative;
    z-index: 150;
    width: ${props => props.width};
    right: ${props => props.right};

    img {
        width:100%;
    }

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        width: 100%;
    }
`

const ParallaxContainer = styled.div`
    overflow: hidden;

`;

const Ref = styled.div`
    background:${props => `${props.theme.colors.primary}`};
    width: 1px;
    height:114px;
    display:flex;
    justify-content: center;
    position:relative;
    margin-top:-90px;
    margin-left:15%;

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        margin-bottom: 3rem;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        left: 0;
        margin-left: 20px;
    }

    &::before{
        position: absolute;
        content: " ";
        display:block;
        width:5px;
        height:5px;
        border-radius: 50%;
        bottom:0;
        background-color:${props => props.theme.colors.primary};
    }

    &::after {
        color:${props => props.theme.colors.primary};
        display:block;
        width: 500px;
        text-align:left;
        position: absolute;
        content:" ${props => props.refContent}";
        left:10px;
        bottom:-8px;
        font-family:${props => props.theme.fonts.display};
        font-weight: 400;
        font-size: 1em;
        text-transform: uppercase;
    }
`



const Image = (props) => {

    const parallaxElement = useRef(null)
    const [scrollY, setScrollY] = useState(0)

    useElementInertialParallax((parallaxValue) => {
        setScrollY(15 - parallaxValue * 30)
    }, parallaxElement)

    let imageSource = props.imageSource

    return (
        <ImageContainer width={props.width}>
            <ParallaxContainer ref={parallaxElement}>
                <img src={require(`../../../../assets/img/Stock_images/${imageSource}`).default} style={ { transform: `translate3d(0,${scrollY}%,0) scale(1.3)` } } />
            </ParallaxContainer>
            {props.refContent != "-" ? <Ref refContent={props.refContent}></Ref> : ""}
        </ImageContainer>
    );
};

export default Image;